module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 member member-form"
  }, [_vm._m(0), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-filter-member"
  }, [_vm._m(1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tìm theo tên hiển thị")]), _c('Select2', {
    staticClass: "select2-style",
    attrs: {
      "id": "filter",
      "options": _vm.lstUsers,
      "settings": _vm.settingSelect2
    },
    on: {
      "select": function($event) {
        return _vm.selectUserEvent($event)
      }
    }
  })], 1), _c('div', {
    staticClass: "list-meber-selected"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "box-custom-padding"
  }, _vm._l((_vm.lstUsersSelected), function(userSelected, index) {
    return (_vm.lstUsersSelected !== null && _vm.lstUsersSelected.length > 0) ? _c('div', {
      staticClass: "col-md-2 col-xs-4 box-item-friend"
    }, [_c('templateInfo', {
      attrs: {
        "item": userSelected.user
      },
      on: {
        "onClickRemove": _vm.onClickRemove
      }
    })], 1) : _vm._e()
  }), 0)])])]), _c('div', {
    staticClass: "box-public-member"
  }, [_c('label', {
    staticClass: "title-note"
  }, [_vm._v("Chọn các Cộng đồng bạn muốn mời các thành viên trên tham gia")]), _vm._l((_vm.lstPCs), function(item, index) {
    return (_vm.lstPCs !== null && _vm.lstPCs.length > 0) ? _c('div', [(item.classes.length > 0) ? _c('templateItem', {
      key: _vm.keyIncrement,
      attrs: {
        "item": item
      },
      on: {
        "onClickChecked": _vm.onClickChecked
      }
    }) : _vm._e()], 1) : _vm._e()
  })], 2), _c('div', {
    staticClass: "item-pc-bottom"
  }, [_c('button', {
    staticClass: "active",
    on: {
      "click": _vm.createUserToPC
    }
  }, [_vm._v("Thêm mới")]), _c('button', {
    on: {
      "click": _vm.cancelRequest
    }
  }, [_vm._v("Huỷ yêu cầu")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_header"
  }, [_c('label', {
    staticClass: "title"
  }, [_vm._v("Thêm mới thành viên")]), _c('div', {
    staticClass: "clearfix"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "title-note"
  }, [_vm._v("Chọn thành viên bạn muốn mời tham gia")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc79c50c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member/add.vue
// module id = 1649
// module chunks = 0